export type Faixa = 'RB' | 'RM' | 'RA' | 'RE';

export interface FaixaDeRisco {
    faixa: Faixa;
    fill: string;
    border: string;
}

/**
 * Cores canonicas da plataforma, identicas em
 * src/_metronic/assets/sass/style.scss e no relatorio PDF do backend.
 */
export const CORES_POR_FAIXA: Record<Faixa, { fill: string; border: string }> = {
    RB: { fill: 'rgba(71, 190, 125, 0.35)',  border: '#47be7d' },
    RM: { fill: 'rgba(238, 227, 70, 0.35)',  border: '#EEE346' },
    RA: { fill: 'rgba(255, 170, 59, 0.35)',  border: '#ffaa3b' },
    RE: { fill: 'rgba(217, 33, 78, 0.35)',   border: '#d9214e' },
};

/**
 * Faixas de risco da plataforma: RB 0-10, RM 10-40, RA 40-80, RE 80-100.
 * Limite inferior inclusivo, superior exclusivo, exceto RE que fecha em 100.
 */
export function faixaDeRisco(nivel: number): FaixaDeRisco {
    let faixa: Faixa;

    if (nivel < 10) {
        faixa = 'RB';
    } else if (nivel < 40) {
        faixa = 'RM';
    } else if (nivel < 80) {
        faixa = 'RA';
    } else {
        faixa = 'RE';
    }

    return { faixa, ...CORES_POR_FAIXA[faixa] };
}
